import FullscreenToggle from './FullscreenToggle';
import MuteToggle from './MuteToggle';

const OriginalGamesFooter: FC = () => (
  <div className="flex w-full justify-end gap-2 py-4" data-testid="game-footer">
    <MuteToggle />
    <FullscreenToggle />
  </div>
);

export default OriginalGamesFooter;
